adminApp.component('adminPlatformGroup', {
    templateUrl: '/public/components/adminPlatformGroup.html',
    bindings: {
        /*
         * this will hold the structure of groups
         * and platforms
        */
        socketVersion: '=',
        versionName: '='
    },
    controller: adminPlatformGroupCtrl

});

function adminPlatformGroupCtrl () {

}